<template>
  <div>
    <el-drawer
      :destroy-on-close="true"
      title="设置"
      :visible.sync="spriteSetting"
      direction="rtl"
      size="30%"
      :append-to-body="true"
      @close="close"
    >
    <!-- 单选组件 -->
      <div
        class="drawer__content"
        v-if="showSetting == settingType.propSetting"
      >
        <el-tabs v-model="activeName">
          <el-tab-pane label="属性" name="prop"
            ><prop-component></prop-component
          ></el-tab-pane>
          <el-tab-pane label="事件" name="event"
            ><event-component></event-component
          ></el-tab-pane>
          <el-tab-pane label="动画" name="animation"
            ><animation-component></animation-component
          ></el-tab-pane>
          <el-tab-pane label="数据" name="data"
            ><data-component></data-component
          ></el-tab-pane>
        </el-tabs>
      </div>

      <!-- 多选组件 -->
      <div
        class="drawer__content"
        v-if="showSetting == settingType.propsSetting"
      >
        <el-tabs v-model="propsActiveName">
          <el-tab-pane label="属性" name="prop"
            ><props-component></props-component
          ></el-tab-pane>
        </el-tabs>
      </div>


      <div
        class="drawer__content"
        v-if="showSetting == settingType.dataSetting"
      >
        <el-tabs v-model="activeName2">
          <el-tab-pane label="舞台" name="stage">
            <stage-setting-component></stage-setting-component>
          </el-tab-pane>
          <el-tab-pane label="数据" name="data">
            <data-setting-compoent></data-setting-compoent>
          </el-tab-pane>
          <el-tab-pane label="图层" name="structure">
            <structure-layout></structure-layout>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Core from "@/libs/src/core";

import AnimationComponent from "./setting-compoents/animation.vue";
import propComponent from "./setting-compoents/prop.vue";
import propsComponent from "./setting-compoents/props.vue";
import eventComponent from "./setting-compoents/event.vue";
import DataComponent from "./setting-compoents/data/data.vue";

import StageSettingComponent from "./setting-compoents/stage-setting.vue";
import DataSettingCompoent from "./setting-compoents/data-setting.vue";
import StructureLayout from "./setting-compoents/layout/structure-layout.vue";

// 显示的设置项类型
const settingType = {
  propSetting: 0,
  dataSetting: 1,
  propsSetting: 2,
};

export default {
  props: ["spriteItem"],
  components: {
    propComponent,
    eventComponent,
    AnimationComponent,
    DataComponent,
    StageSettingComponent,
    DataSettingCompoent,
    StructureLayout,
    propsComponent
  },
  data() {
    return {
      activeName: "prop",
      activeName2: "stage",
      propsActiveName:"prop",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      formLabelWidth: "80px",
      timer: null,
      spriteSetting: false,
      attr: {},
      showSetting: settingType.dataSetting,
      settingType,
    };
  },
  created() {
    this.init();
  },
  filters: {
    // 时间格式化
    formatDate(time) {
      return new Date(time).toLocaleDateString();
    },
    // 当前为数组
    isArray(value) {
      return Array.isArray(value);
    },
  },
  destroyed() {
    // 销毁组件时清空事件列表
    this.technology.data.spriteEvents = [];
    this.technology.off("setting");
  },
  methods: {
    // 数组转换成字符串
    arrToStr(arr) {
      if (Array.isArray(arr)) {
        return {
          type: "array",
          data: JSON.stringify(arr),
        };
      }
      return arr;
    },
    init() {
      this.technology = Core.getProvider("TechnologyTopo");
      this.technology.on("setting", (store) => {
        this.spriteSetting = true;
        let active = store.active;
        
        if (active.length == 1) {
          this.showSetting = settingType.propSetting;
          let sprite = active[0];
          // 初始化事件列表
          this.technology.data.spriteEvents = sprite.events || [];
        }
        if (!active.length) {
          // 没有选择
          this.showSetting = settingType.dataSetting;
        }

        if(active.length > 1){
          this.showSetting = settingType.propsSetting;
        }
      });
    },
    close() {
      let spriteEvents = this.technology.data.spriteEvents;
      let active = this.technology.store.active;
      
      if (active.length) {
        let sprite = active[0];
        if (spriteEvents.length) {
          sprite.events = spriteEvents;
        }
        // this.technology.stageCanvas.setValue(sprite);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.drawer__content {
  padding: 15px;
  .prop-item {
    margin-bottom: 10px;
  }
}
</style>